document.addEventListener("DOMContentLoaded", function () {

    const tabs = document.querySelectorAll(".pts-tab-btn");
    const contents = document.querySelectorAll(".pts-tab-content");

    document.querySelectorAll(".pts-tab-content").forEach((tab) => {

        if (window.innerWidth <= 768) return;

        const slider = tab.querySelector(".swiper");

        if (!slider) return;

        new Swiper(slider, {

            slidesPerView: 4,
            spaceBetween: 20,
            loop: true,

            navigation: {
                nextEl: slider.querySelector(".pts-next"),
                prevEl: slider.querySelector(".pts-prev")
            },

            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 4
                }
            }

        });

    });

    tabs.forEach((tab) => {

        tab.addEventListener("click", function () {

            tabs.forEach(btn => btn.classList.remove("active"));
            contents.forEach(c => c.classList.remove("active"));

            this.classList.add("active");

            const active = document.getElementById(this.dataset.tab);

            active.classList.add("active");

            setTimeout(() => {

                const swiper = active.querySelector(".swiper");

                if (swiper && swiper.swiper) {
                    swiper.swiper.update();
                }

            }, 200);

        });

    });

});